import React, { useState, useEffect } from 'react';
import { Message, BULMA, FieldContainer, Spinner, TextInputWithButton } from '@graffer-inc/graffer-ui';
import Http from "../../../http";
import File from "../../../utils/file";
import Transition from '../../../utils/transition';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import PreSettingDone from '../../templates/pre-setting-done';

const Main = ({ match, loginAccount }) => {
  const { entryId } = match.params;

  const [isDownloading, setIsDownloading] = useState(null);
  const [entryInfo, setEntryInfo] = useState(null);
  const [to, setTo] = useState('');

  const downloadInvoice = async () => {
    setIsDownloading(true);
    await Http.fetchEncodedInvoice(
      entryId,
      to,
      async (res) => {
        try {
          File.download(res.data.encoded, `Graffer電子証明書取得サポート領収書_${entryId}.pdf`);
          setIsDownloading(false);
        } catch (e) {
          setIsDownloading(false);
          toast.error('領収書のダウンロードに失敗しました。画面を更新して再度リンクをクリックしてください。');
          console.error(e);
        }
      },
      () => {
        setIsDownloading(false);
        toast.error('領収書のダウンロードに失敗しました。画面を更新して再度リンクをクリックしてください。');
      }
    );
  };

  const fetchEntry = async () => Http.fetchEntry(
    entryId,
    res => setEntryInfo(res.data),
    () => Transition.goTo(`/entries/${entryId}`)
  );

  useEffect(() => {
    fetchEntry();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTo(loginAccount.company.companyName);
  }, [loginAccount]);

  useEffect(() => {
    if (entryInfo && entryInfo.entry.isRefunded) {
      Transition.goTo(`/entries/${entryId}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entryInfo]);

  return (
    <PreSettingDone>
      <div className="container">
        <p className="is-size-3 has-text-weight-bold">領収書のダウンロード</p>
        {entryInfo && !entryInfo.entry.isRefunded ? (
          <>
            <Message color={BULMA.COLOR.INFO}>
              <p>領収書の宛名を入力してダウンロードしてください。</p>
              <p>
                対象の注文の詳細は、
                <a href={`/entries/${entryId}`}>こちら</a>からご確認いただけます。
              </p>
            </Message>
            <div className="columns is-multiline" style={{ maxWidth: '450px' }}>
              <div className="column">
                <FieldContainer name="宛名">
                  <TextInputWithButton
                    isStatic
                    buttonName="様"
                    value={to}
                    placeholder="社名など"
                    onChange={setTo}
                    validate={() => true}
                  />
                </FieldContainer>
                <div style={{ padding: '15px 0' }}>
                  <button
                    className="button is-info is-rounded is-fullwidth"
                    onClick={downloadInvoice}
                    disabled={isDownloading}
                  >
                    {isDownloading ? 'ダウンロード中...' : '領収書をダウンロードする'}
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="has-text-centered" style={{ padding: '100px 0' }}>
            <Spinner />
          </div>
        )}
      </div>
    </PreSettingDone>
  );
};

export default connect(
  store => ({
    loginAccount: store.user.loginAccount,
  }),
)(Main);
